export default __webpack_public_path__ + "static/media/Ylenia Gentile.d877e5bb.jpg";